import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Modal, Spinner, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Pagination from '../../Pagination';
import './AdminDashboard.css';
import DashboardLayout from './DashboardLayout';

const AllowingAccess = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [hrList, setHrList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(20); // Or 20 based on your default
  const [totalPages, setTotalPages] = useState(0);

  const [showPreview, setShowPreview] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedHR, setSelectedHR] = useState(null);

  const handleClosePreview = () => {
    setShowPreview(false);
    setSelectedUserId(null);
    setSelectedHR(null);
  };

  const handleShowPreview = (userId, hr) => {
    setSelectedUserId(userId);
    setSelectedHR(hr);
    setShowPreview(true);
  };

  useEffect(() => {
    fetchHRList();
  }, [page, size]);

  const fetchHRList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_API_URL}/getListOfHR?page=${page}&size=${size}`);
      setHrList(response.data.content); // Assuming Spring Page response
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching HR list", error);
      setHrList([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };


  const handleApprove = async (email, hr) => {
    try {
      const response = await axios.put(`${BASE_API_URL}/verify-designation`, null, {
        params: {
          userEmail: email,
        },
      });

      Swal.fire({
        icon: 'success',
        title: 'Designation Approved',
        html: `<strong>${hr.companyName}</strong><br>${hr.userEmail}<br><em>${hr.designation}</em> has been verified.`,
      });

      // Refresh list
      fetchHRList();
    } catch (error) {
      console.error("Error approving designation:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to approve designation. Please try again.',
      });
    }
  };

  const handleReject = (hr) => {
    Swal.fire({
      icon: 'info',
      title: 'Designation Rejected',
      html: `<strong>${hr.companyName}</strong><br>${hr.userEmail}<br><em>${hr.designation}</em> is not approved.`,
    });
  };



  const handlePageClick = (data) => {
    setPage(data.selected);
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setSize(size);
    setPage(0); // Reset page when page size changes
  };

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;
  return (
    <DashboardLayout>

      <div className="main-content">
        <div className='table-details-list table-wrapper'>
          <h3>HR List (Unverified Designation)</h3>
          {loading ? (
            <Spinner animation="border" />
          ) : hrList.length > 0 ? (
            <>
              <Table hover c >
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Company</th>
                    <th>Designation</th>
                    <th>LinkedIn</th>
                    <th>Visiting Card</th>
                    <th>Verification Action</th>
                  </tr>
                </thead>
                <tbody>
                  {hrList.map((hr, index) => (
                    <tr key={index}>
                      <td>{hr.userEmail}</td>

                      <td>{hr.companyName}</td>
                      <td>{hr.designation}</td>
                      <td>
                        {hr.linkedInLink ? (
                          <a href={hr.linkedInLink} target="_blank" rel="noopener noreferrer">View</a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td>
                        {hr.visitingCard ? (
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowPreview(hr.userId, hr)}
                          >
                            Preview
                          </Button>
                        ) : (
                          "Not uploaded"
                        )}
                      </td>

                      <td>
                        <Button variant="success" size="sm" onClick={() => handleApprove(hr.userEmail, hr)}>Approved</Button>{' '}
                        <Button variant="danger" size="sm" onClick={() => handleReject(hr)}>Rejected</Button>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Pagination
                page={page}
                pageSize={size}
                totalPages={totalPages}
                handlePageSizeChange={handlePageSizeChange}
                isPageSizeDisabled={isPageSizeDisabled}
                handlePageClick={handlePageClick}
              />
            </>
          ) : (
            <h4 className='text-center'>No data found</h4>
          )}
        </div>
        {/* Preview Modal */}
        <Modal show={showPreview} onHide={handleClosePreview} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Preview Visiting Card</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {selectedUserId ? (
              <img
                src={`${BASE_API_URL}/getVisitingCard/${selectedUserId}`}
                alt="Visiting Card Preview"
                style={{ maxWidth: '100%', maxHeight: '70vh' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `<p class="text-muted">Preview not available. Please download the file to view.</p>`;
                }}
              />
            ) : (
              <p className="text-muted">No preview available</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClosePreview}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

      </div>

    </DashboardLayout>
  )
}

export default AllowingAccess